module.exports = __webpack_public_path__ + "static/Best_perfor_background-f7273fa621fc6b4ba61cdd4ecdde008a.svg";